export const hotelCheckoutGuestDraftKey = (traceId, hotelId) =>
  `hotelCheckoutGuestDraft:${traceId || "notrace"}:${hotelId || "nohotel"}`;

export const readHotelCheckoutGuestDraft = (traceId, hotelId) => {
  try {
    const raw = sessionStorage.getItem(
      hotelCheckoutGuestDraftKey(traceId, hotelId),
    );
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
};

export const writeHotelCheckoutGuestDraft = (traceId, hotelId, draft) => {
  try {
    sessionStorage.setItem(
      hotelCheckoutGuestDraftKey(traceId, hotelId),
      JSON.stringify(draft),
    );
  } catch {
    // ignore quota / private mode
  }
};

export const clearHotelCheckoutGuestDraft = (traceId, hotelId) => {
  try {
    sessionStorage.removeItem(hotelCheckoutGuestDraftKey(traceId, hotelId));
  } catch {
    // ignore
  }
};

/** First and last name: letters only, at least 3 letters. Spaces between words are allowed. */
export const hotelGuestNameRules = [
  { required: true, message: "Required" },
  {
    validator: (_, value) => {
      const raw = String(value ?? "").trim();
      if (!raw) return Promise.resolve();
      if (!/^[A-Za-z]+(?: [A-Za-z]+)*$/.test(raw)) {
        return Promise.reject(new Error("Use alphabets only"));
      }
      if (raw.replace(/ /g, "").length < 3) {
        return Promise.reject(new Error("Minimum 3 letters"));
      }
      return Promise.resolve();
    },
  },
];
